/* tslint:disable */
/* eslint-disable */
/**
 * Sports App Training Plans
 * API for the Sports App Training Plans
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  SubscriptionComplete,
} from '../models/index';
import {
    SubscriptionCompleteFromJSON,
    SubscriptionCompleteToJSON,
} from '../models/index';

/**
 * 
 */
export class StripeApi extends runtime.BaseAPI {

    /**
     */
    async stripeCancelSubscriptionRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/stripe/cancel-subscription`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async stripeCancelSubscription(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.stripeCancelSubscriptionRaw(initOverrides);
    }

    /**
     */
    async stripeCreateSubscriptionRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SubscriptionComplete>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/stripe/subscribe`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SubscriptionCompleteFromJSON(jsonValue));
    }

    /**
     */
    async stripeCreateSubscription(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SubscriptionComplete> {
        const response = await this.stripeCreateSubscriptionRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async stripeStripeWebhookRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/stripe/webhook`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async stripeStripeWebhook(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.stripeStripeWebhookRaw(initOverrides);
    }

}
